import { endpoints } from '../endpoints';
import { parseFile } from '../parseResponse';
import { getHeader } from './generalApi';

export async function downloadApplicationFile(applicationFile) {
  return fetch(`${endpoints.attachments}/applicationFile?gid=${applicationFile.gid}`, {
    ...(await getHeader('GET'))
  }).then(response => parseFile(response, applicationFile.fileName, applicationFile.contentType));
}

export async function downloadCaseEventAttachment(caseEventAttachment) {
  return fetch(`${endpoints.attachments}/caseEventAttachment?gid=${caseEventAttachment.gid}`, {
    ...(await getHeader('GET'))
  }).then(response => parseFile(response, caseEventAttachment.fileName, caseEventAttachment.contentType));
}
